import { useCallback, useState } from "react";
import { ORDER } from "./constants";
import type { Order, Sorting } from "./types";

export interface CompanyRatesTableSortingAction {
  type?: string;
}

export interface CompanyRatesTableSortingHook {
  sorting: Sorting;
  order: Order;
  onAction: (action?: CompanyRatesTableSortingAction) => void;
}

export default function useCompanyRatesTableSorting(): CompanyRatesTableSortingHook {
  const [sorting, setSorting] = useState<Sorting>("provider");
  const [order, setOrder] = useState<Order>(ORDER.NORMAL);

  const onAction = useCallback(
    (action: CompanyRatesTableSortingAction = {}) => {
      const { type } = action;
      const [currentSorting, currentOrder] = type?.split("-") || [];

      setSorting((currentSorting as Sorting) || "provider");
      setOrder(currentOrder === "ascending" ? ORDER.NORMAL : ORDER.INVERSE);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
